// deps
import React, { useContext } from "react";

// internal-deps
import {
    AnalyticsContext,
    CheckoutActionTypes,
    CheckoutContext,
    CheckoutRoute,
    showNativeAlert,
    useNavigate,
} from "@swiggy-private/checkout-core";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { PaymentGroupDataDef, PaymentProgressLoader } from "@swiggy-private/payment-ui";

// helpers
import { sendLinkSuccessStatusToNative } from "@payment-client/helpers/PaylaterHelper";

// contexts
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";

// constants
import { OOPS_SOMETHING_WENT_WRONG } from "@payment-client/constants/TextDict";

// analytics
import { onSimplLinkingFailedImpressionEvent } from "@payment-client/analytics/events/Paylater";

export interface PaylaterLinkingFailedProps {
    paymentGroup: PaymentGroupDataDef;
    error?: boolean | null;
    paymentCode: string;
}

export function PaylaterLinkingFailed({
    paymentGroup,
    error,
    paymentCode,
}: PaylaterLinkingFailedProps): React.ReactElement {
    const { setCheckoutState } = useContext(CheckoutContext);
    const { paymentResponse } = useContext(ShowPaymentContext);
    const navigateTo = useNavigate();
    const { impressionEvent } = useContext(AnalyticsContext);
    useEffectOnce(() => {
        setCheckoutState({ type: CheckoutActionTypes.SHOW_PAYMENTS });
        // if any error it means the the simpl linking is failed with some error and in that case we will show a native alerts
        // otheriwse we will navigate user to the  MORE_PAYMENT_METHODS route
        if (error) {
            onSimplLinkingFailedImpressionEvent(paymentCode, impressionEvent);
            showNativeAlert({ message: OOPS_SOMETHING_WENT_WRONG });
        } else {
            sendLinkSuccessStatusToNative(paymentCode, paymentResponse ? paymentResponse.tenant : undefined);
            navigateTo(CheckoutRoute.MORE_PAYMENT_METHODS, { paymentGroup: paymentGroup });
        }
    });

    return <PaymentProgressLoader />;
}
